import {
    DELETE_ACCOUNT,
    DELETE_ACCOUNT_FAILURE,
    DELETE_ACCOUNT_SUCCESS,
} from 'store/actions/types';

export const deleteAccount = (payload) => {
    return {
        type: DELETE_ACCOUNT,
        payload: payload,
    };
};

export const deleteAccountFailure = (error) => {
    return {
        type: DELETE_ACCOUNT_FAILURE,
        payload: error,
    };
};

export const deleteAccountSuccess = (payload) => {
    return {
        type: DELETE_ACCOUNT_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accounts/deleteAccounts.js